const closeButtonLabel = "Fermer";
const frBE = {
  closeButtonLabel
};
export {
  closeButtonLabel,
  frBE as default
};
